<template>
  <div class="con-tab-ejemplo">
    <p>
      <b>Work Orders</b> - Record what happened or create an unplanned piece of
      work for this asset.
    </p>

    <vs-card style="border-radius: 20px">
      <vs-row>
        <vs-icon color="#459BFF" icon="warning" class="ml-2 mr-2 pb-2"></vs-icon
        ><b class="mt-1">Open WOs</b>
        <vs-spacer></vs-spacer>
        <vs-icon color="primary" icon="cloud_download" class="mr-3"></vs-icon
        ><vs-icon color="#FF8800" icon="print"></vs-icon>
      </vs-row>

      <vs-row>
        <p class="mt-3">You do not have any open WOs</p>
        <vs-spacer />
        <vs-checkbox v-model="checkBox1">Include Children Data</vs-checkbox>
        <vs-icon
          color="#fffff"
          icon="help"
          class="ml-2 mt-2 pt-1"
          size="20px"
        ></vs-icon>
      </vs-row>
      <br>
      <BtnStartWO :priority="priority" />

      <br />
      <br />
      <br />
      <vs-divider />
      <vs-row>
        <vs-checkbox v-model="checkBox1" class="ml-2 mt-2">
          <b>Completed WOs</b>
        </vs-checkbox>
        <vs-spacer></vs-spacer>
        <vs-icon
          color="primary"
          icon="cloud_download"
          class="mr-3 mt-1"
        ></vs-icon>
        <vs-input
          icon-after="true"
          icon="search"
          placeholder="What are you looking for?"
          v-model="value1"
        />
      </vs-row>
      <br />
      <br />
      <p>There are not any completed WOs for this asset</p>
    </vs-card>
  </div>
</template>

<script>
import BtnStartWO from "@/TreeListMaster/button/BtnStartWO";
export default {
  props: {
    priority: Array,
  },
  components: {
    BtnStartWO,
  },
};
</script>

<style>
</style>